import Vue from 'vue'

const API_AUTH_LOGIN = '/api/wx/get_wx_wechat_token'

export default (code, state, success = null, failed = null) => {
  Vue.http.get(API_AUTH_LOGIN, {params: {code, state}})
    .then((resp) => {
      if (success) success(resp)
    })
    .catch((error) => {
      if (failed) failed(error)
    })
}



// WEBPACK FOOTER //
// ./src/api/auth/wx-login.js